module.exports = __webpack_public_path__ + "img/03.599e086c.jpg";